<template>
  <div>
    <p v-if="debugMode">
      active design:
      #{{activeDesign.id}} | {{activeDesign.name}} | {{activeDesign.symbolFormat}} | {{activeDesign.fillings}} | {{activeDesign.shapes}} | {{activeDesign.colors}}
    </p>
    <H2>
      availableDesigns:
    </H2>
  </div>
  <div>
    <table>
      <tr v-for="design in designSets" :key="design.id" :class="activeDesign.id == design.id ? 'active' : ''">
        <td>{{design.id}}</td>
        <td>{{design.name}}</td>
        <td>{{design.symbols?.format}}</td>
        <td>
          <span v-for="color in design.symbols?.colors" :key="color"
                :style="'background-color: ' + color"
          >{{color}}<br></span>
        </td>
        <td>
          <span v-for="filling in design.symbols?.fillings" :key="filling"
                class="color-sample"
          >{{filling}}<br></span>
        </td>
        <td>
          <span v-for="shape in design.symbols?.shapes" :key="shape"
                class="color-sample"
          >{{shape}}<br></span>
        </td>
        <td>
          <span v-for="(cardColor, colorAttribute) in design.cardColors" :key="cardColor"
                class="color-sample"
                :style="'background-color: ' + cardColor"
          >{{colorAttribute}} - {{cardColor}}<br></span>
        </td>
      </tr>
    </table>

  </div>
</template>

<script>
import config from './assets/config.json'
import designSets from './assets/designSets.json'

export default {
  name: 'DebugDesigns',
  data() {
    return {
      config: config,
      designSets: designSets,
      activeDesign: designSets[config.activeDesignId],
      debugMode: config.debugMode
    }
  }

}
</script>


<style scoped>
table {
  border: solid 1px;
  tr.active {
    font-weight: bold;
  }
  td {
    border: solid 1px;
  }
}

</style>
